module.exports = __webpack_public_path__ + "static/img/0759.c1ca400.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/0759.jpg
// module id = 98
// module chunks = 0